import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import {} from 'react';
export default function I18nLoading() {
    return _jsx(_Fragment, { children: "..." });
}
//# sourceMappingURL=loading.view.js.map